/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import BasicUnit from 'astro/server/unit/basic';

import * as Influence from 'astro/util/influence';


export default class extends BasicUnit
{
  installPassiveBenefit ()
  {
    this.getZone().getAttributes().setInfluenceRange(2);
  }


}
